module.exports = __webpack_public_path__ + "media/images/app/collections/trejours-favorites-mobile-3605b08a52ed32d09fbf93201c2c7c9a.webp";